<template>
  <div class="tms">
    <!--模块展示区-->
    <editor :pageData="pageData" :theme="theme"></editor>
  </div>
</template>

<script>
import editor from "./components/Editor";
import { tmsMixin } from "@/js/common/mixin";

export default {
  mixins: [tmsMixin],
  data() {
    return {
      pageList: [],
      pageData: null,
      originData: "",
      theme: {
        color: "#ff4b55",
      },
      isAjax: false,
      groupList: [],
      groupIndex: 0,
      pageIndex: 0,
    };
  },
  components: {
    editor,
  },
  created() {
    this.page_id = this.$route.query.page_id;
    this.access_token = this.$route.query.access_token;
    if (this.access_token && this.access_token.length == 32) {
      lib.cookie.set("access_token", this.access_token);
    }
    this.isPreview = this.$route.query.isPreview || false;
    if (!this.page_id) {
      this.$message.error("缺少页面ID参数");
    }
    this.getPage();
  },
  mounted() {},
  methods: {
    // 根据参数动态设置
    updateShareMeta(shareInfo) {
      // 更新或创建og:title
      this.setMetaTag('property', 'og:description', shareInfo.description)
      this.setMetaTag('property', 'og:image', shareInfo.share_image)
      // 同时设置传统的description标签（可选）
      this.setMetaTag('itemprop', 'description', shareInfo.description)
      this.setMetaTag('itemprop', 'image', shareInfo.share_image)
      this.setMetaTag('name', 'description', shareInfo.description)
    },
    setMetaTag(attrName, attrValue, content) {
      let meta = document.querySelector(`meta[${attrName}="${attrValue}"]`)
      if (!meta) {
        meta = document.createElement('meta')
        meta.setAttribute(attrName, attrValue)
        document.head.appendChild(meta)
      }
      meta.setAttribute('content', content)
    },
    // 获取页面
    getPage() {
      let jsonUrl =
        "https://cdn.mockuai.com/tms/" + this.page_id + ".json?t=" + new Date().getTime();
      if (this.isPreview) {
        lib.tmsapi.get({
          api: "api/test/page/get",
          data: {
            id: this.page_id,
          },
          success: (data) => {
            if (data.data && data.data[0] && !data.data[0].module_list) {
              data.data[0].module_list = [];
            }
            data.data[0].module_list = JSON.parse(data.data[0].module_list);
            this.pageData = data.data[0];
            if (!this.pageData.app_type || this.pageData.app_type == "0") {
              this.pageData.app_type = "seller";
            }
            document.title = data.data[0].name;
            this.originData = JSON.stringify(this.pageData);
          },
          error: (data) => {
            console.log(data);
          },
          complete: () => {
            this.isAjax = false;
          },
        });
      } else {
        $.getJSON(jsonUrl, (data) => {
          if (data && !data.module_list) {
            data.module_list = [];
          }
          data.module_list = JSON.parse(data.module_list);
          this.pageData = data;
          if (!this.pageData.app_type || this.pageData.app_type == "0") {
            this.pageData.app_type = "seller";
          }
          document.title = data.name;
          this.updateShareMeta(data);
          this.originData = JSON.stringify(this.pageData);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tms {
  background: #efefef;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.container-fluid {
  padding: 10px 16px 10px 10px !important;
}
</style>
